<template>
  <div style="height: 100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="TestTable2" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :isBusy="isBusy" @on_query="on_query" @state_change="state_change"
        :show_toolbar_button="[0, 0, 0, 0, 0]" @tool_invoke="tool_invoke" @current_changed="current_changed"
        @on_cell_button_click="on_cell_button_click">
        <template #query>
          销售公司：<el-select size="small" v-model="dataAreaId" filterable clearable placeholder="请选择销售公司" class="w-10">
            <el-option v-for="item in $store.state.biz_data.baseData.CompanyInfo" :key="item.DataArea"
              :label="item.DataArea + ':' + item.CompanyName" :value="item.DataArea"></el-option>
          </el-select>
          <!-- {{$t("common.RouteType")}}：<el-input clearable size="small" style="width: 120px" v-model="RouteType"></el-input> -->
          工序类型：<el-input clearable size="small" style="width: 120px" v-model="RouteType"></el-input>
        </template>
      </TableMain>
    </BaseContainer>
  </div>
</template>

<script>
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"
import BaseModal from "../components/modals/baseModal"
import TestQueryPanel from "../components/base/TestQueryPanel"
import * as ColorGroupTBLController from "../../controllers/base/ColorGroupTBLController"

export default {
  name: "Worker",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_product_parts",
      },
      fields: ColorGroupTBLController.fields.default,
      dataForm: _.cloneDeep(ColorGroupTBLController.dataForm),
      rules: ColorGroupTBLController.rules,
      RouteType: "",
      dataAreaId: "",
      isBusy: false,
    }
  },
  created() { },
  methods: {
    //#region 查询
    async on_query(set_data) {
      this.isBusy = true
      set_data([])
      let p = { RouteType: { like: "%" + this.RouteType + "%" } }
      if (this.dataAreaId != "") {
        p.dataAreaId = { "=": this.dataAreaId }
      }
      let _result = await ColorGroupTBLController.methods.getData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["id"], ["asc"]))
      }
      this.isBusy = false
    },
    //#endregion

    //#region 保存
    //#endregion

    //#region 状态切换
    // state_change(data, cb) {

    // },
    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) {

      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t("table.table_customer"),
          sheet_title: "部件档案",
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },
    //#endregion

    ///cell点击
    on_cell_button_click(data) {

    },

    current_changed(old, current) {

      this.$emit("current_changed", old, current)
    },
  },
}
</script>
